// extracted by mini-css-extract-plugin
export default {"RootDefault":"RootDefault_RootDefault__EghDp","RootDefaultBody":"RootDefault_RootDefaultBody__BjCkO"};